import * as Actions from "./constants/chatActionTypes.js";
import { fetchArticleData } from "actions/fetch";
import { openWebPagesModal } from "./webPagesTabActions.js";
import { viewArticle, viewSocialMediaArticle } from "./mediaTab.js";
import { openContentModal, closeContentModal } from "./content.js";
import { explorerNavigation } from "./navigation.js";

import {
	DATASET_ID_SOCIAL_MEDIA,
	DATASET_ID_MEDIA,
	DATASET_ID_NARRATIVES,
	DATASET_ID_WEB,
} from "layout/DataExplorer/DataExplorerConstants.js";

export function openChatModal() {
	return (dispatch, getState) => {
		dispatch({ type: Actions.CHAT_OPEN_MODAL });
	};
}

export function closeChatModal() {
	return (dispatch, getState) => {
		dispatch({ type: Actions.CHAT_CLOSE_MODAL });
	};
}

export function setChatShowAllSources(show) {
	return (dispatch) => {
		dispatch({ type: Actions.CHAT_SET_SHOW_ALL_SOURCES, show });
	};
}

export function openChatReference(id, index) {
	return (dispatch, getState) => {
		dispatch({ type: "resetContentModal" });
		dispatch(fetchArticleData({id, index}));
		dispatch({ type: "openContentModal" });
	};
}

export function closeChatReference(id, index) {
	return (dispatch, getState) => {
		dispatch(closeContentModal());
	};
}

export const closeMultiChatModal = () => ({
	type: Actions.CLOSE_MULTI_CHAT_MODAL,
});

export const openMultiChatModal = () => ({
	type: Actions.OPEN_MULTI_CHAT_MODAL,
});

export const updateChatHistory = (chatId, messagesOrUpdater) => (dispatch, getState) => {
	const currentHistory = getState().chat.chatHistory;
	const newMessages = typeof messagesOrUpdater === 'function' 
		? messagesOrUpdater(currentHistory[chatId] || [])
		: messagesOrUpdater;

	dispatch({
		type: Actions.UPDATE_CHAT_HISTORY,
		chatId,
		payload: newMessages,
	});
};

export const clearChatHistory = (chatId) => {  
	return ({
		type: Actions.CLEAR_CHAT_HISTORY,
		chatId,
	})
};

export const setPanelChatHistory = (history) => ({
	type: Actions.SET_PANEL_CHAT_HISTORY,
	payload: history
});

export const setSidebarChatHistory = (history) => ({
	type: Actions.SET_SIDEBAR_CHAT_HISTORY,
	payload: history
});

export const setCurrentSessionId = (chatId, sessionId) => {  
	return ({
		type: Actions.SET_CURRENT_SESSION_ID,
		chatId,
		sessionId,
	})
};

export const setSessionLoading = (chatId, loading) => {  
	return ({
		type: Actions.SET_SESSIONS_LOADING,
		chatId,
		loading,
	})
};

export const setActiveSources = (chatId, msgId, sources, citations, debugData) => {  
	return ({
		type: Actions.SET_ACTIVE_SOURCES,
		chatId,
		msgId,
		sources,
		citations,
		debugData,
	})
};

export const setActiveChatConfig = (chatId, config) => {  
	return ({
		type: Actions.SET_ACTIVE_CHAT_CONFIG,
		chatId,
		config,
	})
};

export const updateChatOptions = (options) => ({
	type: Actions.UPDATE_CHAT_OPTIONS,
	payload: options
});


export const setForceSingleDocChatDisplay = () => ({
	type: Actions.SET_FORCE_SINGLE_DOC_CHAT_DISPLAY
});

export const clearForceSingleDocChatDisplay = () => ({
	type: Actions.CLEAR_FORCE_SINGLE_DOC_CHAT_DISPLAY
});

export const openChatDocumentReference = (doc, evt, defDataset, search, navFunc, openingChatSession) =>  (dispatch) => { 
	if (openingChatSession) {
		// Force display of chat when the relevant page/modal opens
		dispatch(setForceSingleDocChatDisplay());
	}
	// Open the relevant document
	switch (doc.dataset || defDataset) {

		case DATASET_ID_SOCIAL_MEDIA:
			if (doc.id && doc.index && doc.social_type) {
				dispatch(viewSocialMediaArticle(doc, evt));
			}
			break;
		
		case DATASET_ID_MEDIA: 	
			if (doc.id && doc.index) {
				const data = {id: doc.id, index: doc.index,	search};
				dispatch(viewArticle(data, evt));
			}
			break;
		
		case DATASET_ID_NARRATIVES:	
			if (doc.id && doc.index) {
				const data = {id: doc.id, index: doc.index,	search};
				dispatch(openContentModal(DATASET_ID_NARRATIVES, data, evt));
			}
			break;
		
		case DATASET_ID_WEB:
			if (doc.htmlHash && doc.urlHash) {
				dispatch(openWebPagesModal({html_hash: doc.htmlHash, url_hash: doc.urlHash}));
			}
			break;
		
		default:
			if (doc.id && doc.index && (doc.dataset || defDataset)) {
				if (navFunc) {
					navFunc(doc.dataset || defDataset, doc.index, doc.id);
				}
				else {
					dispatch(explorerNavigation(doc.dataset || defDataset, doc.index, doc.id));
				}
			}
			break;
	}
};

export const appendChatHistory = (history, pageLength, context = 'panel') => ({
	type: Actions.APPEND_CHAT_HISTORY,
	payload: history,
	pageLength,
	context
});

export const setChatHasNextPage = (hasNextPage) => ({
	type: Actions.SET_CHAT_HAS_NEXT_PAGE,
	payload: hasNextPage
});